import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RedirectToProps {
  path: string;
}

export function RedirectTo({ path }: RedirectToProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(path, { replace: true });
  }, [navigate, path]);

  return null;
}

interface LogoutRouteProps {
  onLogout: () => void;
}

export function LogoutRoute({ onLogout }: LogoutRouteProps) {
  useEffect(() => {
    onLogout();
  }, [onLogout]);

  return null;
}
